// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import CheckBox from "metabase/core/components/CheckBox";

export const CheckboxLabel = styled(CheckBox.Label)`
  color: var(--mb-color-danger);
  font-size: 1.12em;
`;
